import { getAndroidVersion } from "../utils/get-android-version";

export const fragmentShader = `
    ${parseInt(getAndroidVersion(), 10) !== 6 ? "precision highp float;" : "precision mediump float;"}
    uniform vec4 u_color;

    void main() 
    {
      // gl_FragColor - специальная переменная фрагментного шейдера, отвечает за установку цвета.
      gl_FragColor = u_color;
    }
  `;

export const vertexShader = `
  ${parseInt(getAndroidVersion(), 10) !== 6 ? "precision highp float;" : "precision mediump float;"}
  attribute vec2 a_position; // позиция точки (в px)

  uniform vec2 u_shift; // смещение по x и y
  uniform float u_rollIndex;  // индекс точки для roll режима
  uniform vec2 u_scale; // Масштаб (x - width, y - height)
  uniform vec2 u_windowSize; // Размеры окна для отрисовки

  float mod2(float a, float b)
  {
    float res;
    if(a == b) {
      res = a;
    }
    else {
      res = mod(a,b);
    }

    return res;
  }

  void main() 
  {
    // Применяем roll индексацию
    vec2 position = a_position;
    if (u_rollIndex != 0.0) {
      position.x = mod2(position.x, u_rollIndex);
    }
    // Масштабируем
    vec2 scaledPosition = position * u_scale;
    // Смещаем
    vec2 shiftedPosition = scaledPosition + u_shift;
    // Переводим в координаты WebGL
    vec2 webglPosition  = (shiftedPosition / u_windowSize) * 2.0 - 1.0;
    gl_Position = vec4(webglPosition, 0, 1); 
  }`;
